import { toast } from 'vue3-toastify'

import { defineNuxtPlugin } from '#app'

// 全域為「所有 toast」加上橫向滑動關閉（左右皆可）。
// 因多數 toast 為純字串內容、不經 ToastBar，故以事件委派處理每個 .Toastify__toast，
// 而非寫在單一內容元件內。dismiss 透過 toast 根元素的 id（= toastId）呼叫 toast.remove。
export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window === 'undefined') return

  const TOAST_SELECTOR = '.Toastify__toast'
  const SWIPE_THRESHOLD = 45 // 橫向位移超過即關閉
  const AXIS_LOCK_SLOP = 6 // 判定主軸前的容許抖動
  const EXIT_DURATION = 200

  let toastEl = null
  let startX = 0
  let startY = 0
  let currentDx = 0
  let axis = null // 'x' | 'y' | null
  let exitTimer = null

  const resetStyle = (el) => {
    el.style.transition = 'transform 0.2s, opacity 0.2s'
    el.style.transform = 'translateX(0)'
    el.style.opacity = '1'
  }

  const onTouchMove = (e) => {
    if (!toastEl) return
    const touch = e.touches[0]
    if (!touch) return
    const dx = touch.clientX - startX
    const dy = touch.clientY - startY

    if (axis === null) {
      if (Math.abs(dx) < AXIS_LOCK_SLOP && Math.abs(dy) < AXIS_LOCK_SLOP) return
      axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'
    }
    if (axis !== 'x') return // 垂直手勢交還頁面捲動

    if (e.cancelable) e.preventDefault()
    currentDx = dx
    const width = toastEl.offsetWidth || 1
    toastEl.style.transition = 'none'
    toastEl.style.transform = `translateX(${dx}px)`
    toastEl.style.opacity = String(Math.max(0, 1 - Math.abs(dx) / width))
  }

  const onTouchEnd = () => {
    window.removeEventListener('touchmove', onTouchMove)
    window.removeEventListener('touchend', onTouchEnd)
    window.removeEventListener('touchcancel', onTouchEnd)

    const el = toastEl
    toastEl = null
    if (!el) return

    if (axis === 'x' && Math.abs(currentDx) >= SWIPE_THRESHOLD) {
      const direction = currentDx > 0 ? 1 : -1
      const width = el.offsetWidth || 300
      el.style.transition = `transform ${EXIT_DURATION}ms ease-out, opacity ${EXIT_DURATION}ms ease-out`
      el.style.transform = `translateX(${direction * width}px)`
      el.style.opacity = '0'
      const id = el.id
      exitTimer = setTimeout(() => id && toast.remove(id), EXIT_DURATION)
    } else {
      resetStyle(el)
    }
    axis = null
    currentDx = 0
  }

  const onTouchStart = (e) => {
    const target = e.target?.closest?.(TOAST_SELECTOR)
    if (!target) return
    const touch = e.touches[0]
    if (!touch) return
    toastEl = target
    startX = touch.clientX
    startY = touch.clientY
    currentDx = 0
    axis = null
    // 拖曳期間才掛 move/end，避免常駐 non-passive touchmove 影響捲動效能
    window.addEventListener('touchmove', onTouchMove, { passive: false })
    window.addEventListener('touchend', onTouchEnd)
    window.addEventListener('touchcancel', onTouchEnd)
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true })

  // SPA 卸載時清理（client 專用，server 無此副作用）
  nuxtApp.hook('app:unmounted', () => {
    if (exitTimer) clearTimeout(exitTimer)
    document.removeEventListener('touchstart', onTouchStart)
    window.removeEventListener('touchmove', onTouchMove)
    window.removeEventListener('touchend', onTouchEnd)
    window.removeEventListener('touchcancel', onTouchEnd)
  })
})
